import { render, staticRenderFns } from "./OrderTmsForm.vue?vue&type=template&id=6b15f790&"
import script from "./OrderTmsForm.vue?vue&type=script&lang=js&"
export * from "./OrderTmsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b15f790')) {
      api.createRecord('6b15f790', component.options)
    } else {
      api.reload('6b15f790', component.options)
    }
    module.hot.accept("./OrderTmsForm.vue?vue&type=template&id=6b15f790&", function () {
      api.rerender('6b15f790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/OrderTmsForm.vue"
export default component.exports